// extracted by mini-css-extract-plugin
export default {"container":"OwnedSecurity_container__8gye7"};